import { render, staticRenderFns } from "./SelectPortal.vue?vue&type=template&id=0656707e&"
import script from "./SelectPortal.vue?vue&type=script&lang=js&"
export * from "./SelectPortal.vue?vue&type=script&lang=js&"
import style0 from "./SelectPortal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports